module.exports = __webpack_public_path__ + "img/zomb_zombietokens.1a840e9.png";